import { type ApiRoleStrategy, ROLES } from "@pharmupp/p3-front-commons"

type OperationConf = {
  readEndpoint?: string
  readQueryKey?: string[]
  hideEndpoint?: string
  subscribeEndpoint?: string
  unsubscribeEndpoint?: string
}

const adherentConf = (operationId: string) => ({
  endpoint: "/api/operation/marketing/adherent",
  queryKey: ["operation", "marketing", "adherent"],
  readEndpoint: `/api/operation/marketing/adherent/${operationId}`,
  readQueryKey: ["operation", "marketing", "adherent", operationId],
  hideEndpoint: `/api/operation/marketing/adherent/${operationId}/hide`,
  subscribeEndpoint: `/api/operation/marketing/adherent/${operationId}/subscribe`,
  unsubscribeEndpoint: `/api/operation/marketing/adherent/${operationId}/unsubscribe`,
})

const presidentConf = (adherentId: string) => ({
  endpoint: `/api/operation/marketing/upp/adherent/${adherentId}`,
  queryKey: ["operation", "marketing", "upp", "adherent", adherentId],
})

export const adhMarketingOPApiRoleConf = (
  adherentId?: string,
  operationId = "",
): ApiRoleStrategy<OperationConf> => ({
  [ROLES.ADHERENT_HOLDER]: adherentConf(operationId),
  [ROLES.ADHERENT_TEAM]: adherentConf(operationId),
  ...(adherentId && {
    [ROLES.ADMIN]: {
      endpoint: `/api/operation/marketing/pharmasheet/adherent/${adherentId}`,
      queryKey: ["operation", "marketing", "pharmasheet", "adherent", adherentId],
    },
    [ROLES.ADHERENT_ADVISOR]: {
      endpoint: `/api/operation/marketing/my-sector/adherent/${adherentId}`,
      queryKey: ["operation", "marketing", "my-sector", "adherent", adherentId],
    },
    [ROLES.UPP_PRESIDENT]: presidentConf(adherentId),
    [ROLES.UPP_REPRESENTATIVE]: presidentConf(adherentId),
  }),
})
